// @flow
import * as React from 'react';

import { Base, Icon, IconContainer, Select } from './styles';

import generalIcons from '~/core/constants/icons/general-svg';
import { injectIntl } from 'react-intl';
import { List } from 'immutable';
import messages from './intl';

type Props = {
    currentValue: number,
    handleChange: number => any,
    intl: $npm$ReactIntl$IntlShape,
    options: List<string | $npm$ReactIntl$MessageDescriptor>,
    color?: string
};
type State = {
    selectedValue: number
};

// $FlowFixMe
class Dropdown extends React.Component<Props, State> {
    state = {
        selectedValue: -1
    };

    constructor(props: Props) {
        super(props);
        const { currentValue } = props;
        this.state = {
            selectedValue: currentValue
        };
    }

    handleSelect = ({ target }: SyntheticInputEvent<>) => {
        const { handleChange } = this.props;
        const index: number = parseInt(target.value, 10);
        handleChange(index);
        this.setState({
            selectedValue: index
        });
    };

    render() {
        const { intl: { formatMessage }, options, color } = this.props;
        const { selectedValue } = this.state;

        const opts = selectedValue === -1 ? [formatMessage(messages.pleaseSelect), ...options] : options;

        return (
            <Base color={color}>
                <Select onChange={this.handleSelect} value={selectedValue}>
                    {opts.map((caption, index) => (
                        <option key={`${index}`} value={selectedValue === -1 ? index - 1 : index}>
                            {}
                            {//$FlowFixMe https://github.com/ConnectedHomes/hivehome-webapp-v3/issues/2995
                            typeof caption === 'string' ? caption : formatMessage(caption, caption.values)}
                        </option>
                    ))}
                </Select>
                <IconContainer color={color}>
                    <Icon type={generalIcons.ARROW_DOWN} />
                </IconContainer>
            </Base>
        );
    }
}

export default injectIntl(Dropdown);



// WEBPACK FOOTER //
// ./src/components/widgets/dropdown/index.js